import { CaseWhenCondition } from "../ars_ldm";
import { isCaseWhenItem } from "./isCaseWhenItem";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a CaseWhenCondition.
 *
 * Validates that the object has the required properties of a CaseWhenCondition:
 * - id: string
 * - caseWhenItems: CaseWhenItem[] (each element passes isCaseWhenItem)
 *
 * @param obj - The value to check.
 * @param isT - Type guard function for the generic type T.
 * @returns True if the value is a CaseWhenCondition.
 */
export const isCaseWhenCondition = <T>(
  obj: unknown,
  isT: (obj: unknown) => obj is T,
): obj is CaseWhenCondition<T> => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (!Array.isArray(obj.caseWhenItems)) return false;
  if (obj.caseWhenItems.some((item) => !isCaseWhenItem<T>(item, isT))) return false;

  return true;
};
